__webpack_require__.p = "https://bmidxbnetherlandsplpreprod.netlify.app/";